import { resolvers } from './resolvers';
import {
  ApolloClient,
  NormalizedCacheObject,
  InMemoryCache,
} from '@apollo/client';
import typeDefs from './schema';
import { TrelloWindow } from '@trello/window-types';
import { typePolicies } from './typePolicies';
declare const window: TrelloWindow;

export const client: ApolloClient<NormalizedCacheObject> = new ApolloClient({
  cache: new InMemoryCache({ typePolicies }),
  resolvers,
  typeDefs,
  ...(window.__DEV__ && { connectToDevTools: true }),
});
